import React, { useEffect, useState } from 'react';
import { Link as LinkRouter } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';

import NavSectionLink from './NavSectionLink';
import './Navbar.scss';

import logo from '../../assets/logo.png';
import Modal from '../Modal/Modal';

const Navbar = () => {
  const [sticky, setSticky] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [modalState, setModalState] = useState(false);

  useEffect(() => {
    const onScroll = () => setSticky(window.scrollY > 100);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toggleMenu = () => setMobileMenu((open) => !open);

  const onclickCategory = (index) => {
    setActiveIndex(index);
    setMobileMenu(false);
  };

  const openMessageModal = (index) => {
    onclickCategory(index);
    setModalState(true);
  };

  return (
    <nav className={`site-nav ${sticky ? 'dark-nav' : ''}`}>
      <div className="logo">
        <LinkRouter to="/"><img src={logo} alt="ICI Cluster" /></LinkRouter>
      </div>
      <ul className={mobileMenu ? '' : 'hide-mobile-menu'}>
        <li className={activeIndex === 0 ? 'active' : ''}>
          <NavSectionLink to="program" onClick={() => onclickCategory(0)}>
            Who are we?
          </NavSectionLink>
        </li>
        <li className={activeIndex === 1 ? 'active' : ''}>
          <NavSectionLink to="part" onClick={() => onclickCategory(1)}>
            Our partners
          </NavSectionLink>
        </li>
        <li className={activeIndex === 2 ? 'active' : ''}>
          <NavSectionLink to="services" onClick={() => onclickCategory(2)}>
            Our services
          </NavSectionLink>
        </li>
        <li className={activeIndex === 3 ? 'active' : ''}>
          <LinkRouter to="/events" onClick={() => onclickCategory(3)}>Our Events</LinkRouter>
        </li>
        <li className={activeIndex === 4 ? 'active' : ''}>
          <LinkRouter to="/news" onClick={() => onclickCategory(4)}>News</LinkRouter>
        </li>
        <li className={activeIndex === 5 ? 'active' : ''}>
          <NavSectionLink to="footer" onClick={() => onclickCategory(5)}>
            Contacts
          </NavSectionLink>
        </li>
        <li className={activeIndex === 6 ? 'active' : ''}>
          <button type="button" className="btn nav-message-btn" onClick={() => openMessageModal(6)}>
            Leave your message
          </button>
        </li>
      </ul>
      <p className="menu-icon" onClick={toggleMenu}>
        {mobileMenu ? <FiX /> : <FiMenu />}
      </p>
      <Modal call={modalState} onDestroy={() => setModalState(false)} />
    </nav>
  );
};

export default Navbar;
